<template>
    <div class="width">
        <div class="width">
            <el-carousel
                indicator-position="none"
                :height="screenheight"
                :arrow="num1 + 1 <= 1 ? 'never' : 'hover'"
            >
                <el-carousel-item
                    v-for="(item, num1) in bannerlist"
                    :key="num1"
                >
                    <img :src="item.url" class="el-image" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="secondheader">
            <div class="main">
                <div class="tip-2nd">反诈培训课程</div>
                <div class="introduce-2nd">
                    培养反诈人才，建设反诈队伍，推广反诈文化
                </div>
                <el-row :gutter="24">
                    <el-col :span="8" :sm="8">
                        <div class="background-image2nd">
                            <img src="../../../admin/assets/images/icon2.png" />
                            <p class="title-2nd">
                                反诈宣讲师
                            </p>
                            <p class="text-2nd">
                                建设标准课程 提升宣教能力 分享方法技能
                                赋能反诈队伍
                            </p>
                        </div>
                    </el-col>
                    <el-col :span="8" :sm="8">
                        <div class="background-image2nd">
                            <img src="../../../admin/assets/images/icon3.png" />
                            <p class="title-2nd">
                                反诈安全员
                            </p>
                            <p class="text-2nd">
                                构建严防体系 培养专业人员 落实反诈责任
                                强化反诈治理
                            </p>
                        </div>
                    </el-col>
                    <el-col :span="8" :sm="8">
                        <div class="background-image2nd">
                            <img src="../../../admin/assets/images/icon4.png" />
                            <p class="title-2nd">
                                反诈意识培训
                            </p>
                            <p class="text-2nd">
                                讲解反诈知识 剖析电诈案例 解读法律法规
                                提高反诈意识
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="third">
            <div class="thirdmain">
                <div class="tip-2nd">反诈宣传素材</div>
                <div class="introduce-3rd">
                    多类型素材，助力开展防范电信网络诈骗宣传工作
                </div>
                <div class="main3rd">
                    <div class="left">
                        <div
                            class="four"
                            v-for="(item, index3) in list2"
                            :key="index3"
                            @click="changChecked(index3)"
                        >
                            <img
                                :src="
                                    checkedIndex == item.id
                                        ? item.url
                                        : item.url1
                                "
                                class="img-four"
                            />
                            <div class="titleline">
                                <div class="linetop">{{ item.title }}</div>
                                <div class="linebottom">{{ item.bottom }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <img :src="homeContentImg" class="right-img" />
                    </div>
                </div>
            </div>
        </div>
        <div class="fouth">
            <div class="fouthbox">
                <div class="tip-3rd">反诈宣传活动</div>
                <div class="introduce-fouth">
                    组织多形式、场景的反诈宣传活动，寓教于乐
                </div>
                <div class="fouth-img">
                    <img
                        src="../../../admin/assets/images/five.png"
                        class="fouth-img"
                    />
                </div>
            </div>
        </div>
        <div class="fifth">
            <div class="fifthmain">
                <div class="fifthbox">
                    <div class="tip-2nd">反诈应急演练</div>
                    <div class="introduce-fifth">
                        场景化与网络钓鱼，提升电诈事件的应急处置能力
                    </div>
                    <div class="fifth-img">
                        <img
                            src="../../../admin/assets/images/five1.png"
                            class="fifth-img"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="six">
            <div class="sixbox">
                <div class="mod">
                    <div class="tip-six">反诈要闻</div>
                    <div @click="more">更多>></div>
                </div>
                <img
                    src="../../../admin/assets/images/line1.png"
                    class="image-line"
                />
                <div class="op">
                    <div
                        v-for="(item, index4) in list3"
                        :key="index4"
                        class="list3"
                        @click="newsInfo(item.id, item.type)"
                    >
                        <div class="head3">
                            <div class="date">
                                {{ item.push_date.substr(5, 6) }}
                            </div>
                            <div class="type">{{ item.name }}</div>
                        </div>
                        <div class="bottom3">
                            <div class="year">
                                {{ item.push_date.substr(0, 4) }}
                            </div>
                            <p class="thing">{{ item.brief }}</p>
                        </div>
                    </div>
                </div>
                <div class="divid-a"></div>
                <div class="divid-b"></div>
                <div class="divid-c"></div>
                <div class="divid-d"></div>
                <div class="divid-e"></div>
            </div>
        </div>
        <div class="end">
            <div class="screen">
                <div class="screen-between">
                    <div>
                        <div class="our">关于我们</div>
                        <img
                            src="../../../admin/assets/images/line1.png"
                            class="image-line1"
                        />
                    </div>
                    <img
                        src="../../../admin/assets/images/img3.png"
                        class="city"
                    />
                </div>
                <div class="foot-text">{{ yu }}</div>
                <div class="tel">
                    <div class="telephone-1st">
                        <span class="telephone">官方热线：40067-96110</span>
                    </div>
                    <div class="telephone-2nd">
                        <span class="telephone">客服电话：15316980213</span>
                    </div>
                    <div class="telephone-3rd">
                        <span class="telephone"
                            >咨询邮箱：guest@hicore.com</span
                        >
                    </div>
                </div>
                <div class="footerbox">
                    <div class="box-footer">
                        <img
                            src="../../../admin/assets/images/foot-icon3.png"
                            class="box-footer-img"
                        />
                        <div class="box-footer-text">
                            <p class="box-tip-1st">国家反诈中心支撑单位</p>
                            <p class="box-tip-2nd">
                                黑瞳科技为国家反诈中心APP及系统后台提供规划、设计、开发、运营、维护等支撑工作，目前APP已经在反电诈工作中产生良好成效。
                            </p>
                        </div>
                    </div>
                    <div class="box-footer">
                        <img
                            src="../../../admin/assets/images/foot-icon.png"
                            class="box-footer-img"
                        />
                        <div class="box-footer-text">
                            <p class="box-tip-1st">
                                国家互联网应急中心支撑单位
                            </p>
                            <p class="box-tip-2nd">
                                黑瞳科技被推选为国家互联网应急中心反网络诈骗领域应急服务支撑单位，为CNCERT提供反诈的网络监测，风险预警，危机处置等多项技术支撑服务。
                            </p>
                        </div>
                    </div>
                    <div class="box-footer">
                        <img
                            src="../../../admin/assets/images/foot-icon2.png"
                            class="box-footer-img"
                        />
                        <div class="box-footer-text">
                            <p class="box-tip-1st">公安部查控中心支撑单位</p>
                            <p class="box-tip-2nd">
                                黑瞳科技为公安部查控中心提供全量级实时数据反馈，查控中心为全国打击防范电信网络诈骗提供资金流、通讯流支撑，并为公安部大数据警务建设提供技术支撑服务。
                            </p>
                        </div>
                    </div>
                    <div class="box-footer">
                        <img
                            src="../../../admin/assets/images/foot-icon4.png"
                            class="box-footer-img"
                        />
                        <div class="box-footer-text">
                            <p class="box-tip-1st">反诈联合实验室</p>
                            <p class="box-tip-2nd">
                                黑瞳科技与中科院联合成立反诈顶级研发平台反诈联合实验室。开展大数据科学理论、大数据建模与挖掘算法、大数据基础技术在反诈风险领域的研究。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
export default {
    name: "addhome",
    data() {
        return {
            index: 0,
            index1: 0,
            index2: 0,
            index3: 0,
            checkedIndex: 0,
            index4: 0,
            index5: "",
            num1: 0,
            homeContentImg: require("../../../admin/assets/images/1.png"),
            newList: [],
            list1: [
                {
                    url: require("../../../admin/assets/images/icon2.png"),
                    title: "反诈宣讲师",
                    log:
                        "建设标准课程  提升宣教能力 分享方法技能  赋能反诈队伍  "
                },
                {
                    url: require("../../../admin/assets/images/icon3.png"),
                    title: "反诈安全员",
                    log: "构建严防体系  培养专业人员 落实反诈责任  强化反诈治理"
                },
                {
                    url: require("../../../admin/assets/images/icon4.png"),
                    title: "反诈意识培训",
                    log: "讲解反诈知识  剖析电诈案例 解读法律法规  提高反诈意识"
                }
            ],
            list2: [
                {
                    url: require("../../../admin/assets/images/icon5_H.png"),
                    url1: require("../../../admin/assets/images/icon5_N.png"),
                    title: "反诈海报",
                    bottom: "专业内容，体系化编排，多场景应用",
                    id: 0,
                    url2: require("../../../admin/assets/images/1.png")
                },
                {
                    url: require("../../../admin/assets/images/icon6_H.png"),
                    url1: require("../../../admin/assets/images/icon6_N.png"),
                    title: "反诈视频",
                    bottom: "简短、生动、直观，随时随地学习",
                    id: 1,
                    url2: require("../../../admin/assets/images/2.png")
                },
                {
                    url: require("../../../admin/assets/images/icon7_H.png"),
                    url1: require("../../../admin/assets/images/icon7_N.png"),
                    title: "反诈手册",
                    bottom: "案例解读，防护技巧，法律法规，实操攻略",
                    id: 2,
                    url2: require("../../../admin/assets/images/3.png")
                },
                {
                    url: require("../../../admin/assets/images/icon8_H.png"),
                    url1: require("../../../admin/assets/images/icon8_N.png"),
                    title: "反诈期刊",
                    bottom: "综合类反诈刊物，紧跟时事热点，探求最佳实践",
                    id: 3,
                    url2: require("../../../admin/assets/images/4.png")
                }
            ],
            list3: [],
            yearlist: [],
            datelist: [],
            postData: {
                page: 1,
                search: "",
                type: ""
            },
            bannerlist: [
                { url: require("../../../admin/assets/images/banner2.jpg") }
            ],
            screenheight: 613 + "px",
            yu:
                "黑瞳科技专注于为政府和机构提供网络风险管控能力建设服务，是国家反诈中心和国家互联网应急中心的支撑单位，参与了国家反电信网络诈骗的基础设施建设工作，在整个反电诈产业生态中占据顶端位置。黑瞳科技与中国科学院共同成立唯一的反欺诈实验室，将海量权威数据与全球领先的知识图谱、神经网络、机器学习等先进技术相结合，真正突破了网络风险智慧管理在政府社会治理、网络风险监测、公安智慧反诈等领域的应用难题。"
        };
    },
    created() {
        this.init();
    },
    methods: {
        changChecked(index3) {
            this.homeContentImg = this.list2[index3].url2;
            this.checkedIndex = index3;
            console.log(this.checkedIndex);
        },
        newsInfo(id, type) {
            this.$router.push({
                path: "/newsDet",
                query: {
                    id: id,
                    type: type
                }
            });
        },
        more() {
            this.$router.push({
                path: "/new"
            });
        },
        init() {
            this.$http
                .get(process.env.VUE_APP_URL + "post", this.postData)
                .then(data => {
                    if (data.data.code == 200) {
                        this.list3 = data.data.data;
                        this.newList = JSON.parse(
                            JSON.stringify(this.list3)
                        ).splice(0, 3);
                        this.list3.sort(function(a, b) {
                            if (a.istop === b.istop) {
                                return (
                                    new Date(b.push_date.replace(/-/g, "/")) -
                                    new Date(a.push_date.replace(/-/g, "/"))
                                );
                            } else {
                                return b.istop - a.istop;
                            }
                        });
                        this.total = data.data.total;
                    } else {
                        this.$message.error(data.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error("网络错误，请重试");
                    console.log(err);
                });
        }
    },
    mounted() {
        if (
            document.documentElement.clientWidth <= 1280 &&
            document.documentElement.clientWidth > 960
        ) {
            this.screenheight = 430 + "px";
        } else if (
            document.documentElement.clientWidth > 1280 &&
            document.documentElement.clientWidth <= 1368
        ) {
            this.screenheight = 441 + "px";
        } else if (
            document.documentElement.clientWidth > 1368 &&
            document.documentElement.clientWidth <= 1440
        ) {
            this.screenheight = 464 + "px";
        } else if (
            document.documentElement.clientWidth > 1440 &&
            document.documentElement.clientWidth <= 1600
        ) {
            this.screenheight = 516 + "px";
        } else if (
            document.documentElement.clientWidth > 1600 &&
            document.documentElement.clientWidth <= 1680
        ) {
            this.screenheight = 541 + "px";
        } else if (
            document.documentElement.clientWidth > 1680 &&
            document.documentElement.clientWidth <= 1920
        ) {
            this.screenheight = 613 + "px";
        } else if (
            document.documentElement.clientWidth > 768 &&
            document.documentElement.clientWidth <= 960
        ) {
            this.screenheight = 310 + "px";
        } else if (document.documentElement.clientWidth <= 768) {
            this.screenheight = 247 + "px";
        }
    }
};
</script>

<style lang="less" scoped>
.width {
    width: 100%;
}
.el-image {
    height: 100%;
    width: 100%;
}
.secondheader {
    width: 100%;
    display: flex;
    justify-content: center;
}
.main {
    width: 1200px;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.tip-2nd {
    height: 36px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1144de;
    margin-top: 40px;
    text-align: center;
}
.introduce-2nd {
    width: 395px;
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #656565;
    line-height: 15px;
    margin-top: 30px;
    margin-bottom: 30px;
}
.background-image2nd {
    background: url("../../../admin/assets/images/three.png") no-repeat;
    background-size: 100% 100%;
    width: 301px;
    height: 250px;
    display: flex;
    justify-content: center;
    background-color: #ffffff;
    flex-direction: column;
    align-items: center;
}
.background-image2nd img {
    margin-top: 20px;
}
.title-2nd {
    width: 120px;
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2c2d2e;
    line-height: 15px;
    margin-bottom: 16px;
    text-align: center;
    margin-top: 10px;
}
.text-2nd {
    width: 210px;
    height: 45px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5c5c5c;
    line-height: 24px;
    text-align: center;
}
.third {
    width: 100%;
    height: 600px;
    background: url("../../../admin/assets/images/bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
}
.main3rd {
    width: 1120px;
    display: flex;
}
.introduce-3rd {
    font-size: 18px;
    font-family: Microsoft YaHei;
    color: #656565;
    line-height: 15px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
}
.linetop {
    width: 86px;
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0c47ea;
    margin-top: 15px;
    margin-bottom: 20px;
}
.linebottom {
    width: 350px;
    height: 19px;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0c1f52;
}
.four {
    display: flex;
    margin-bottom: 20px;
    background: url("../../../admin/assets/images/hover.png") no-repeat;
    width: 450px;
    height: 80px;
}
.titleline {
    display: flex;
    flex-direction: column;
    width: 400px;
    height: 80px;
}
.left {
    width: 600px;
    height: 455px;
    padding-top: 12px;
}
.right {
    width: 600px;
    height: 455px;
}
.img-four {
    width: 50px;
    height: 50px;
    margin-top: 15px;
    margin-left: 10px;
    margin-right: 10px;
}
.fouth {
    width: 100%;
    height: 620px;
    background: url("../../../admin/assets/images/bg2.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.fouth-img {
    width: 1200px;
}
.fouthbox {
    width: 1200px;
    height: 430px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.tip-3rd {
    height: 35px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 34px;
    text-align: center;
}
.introduce-fouth {
    text-align: center;
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 15px;
    padding-top: 25.14px;
    margin-bottom: 40px;
}
.fifth {
    width: 100%;
    height: 520px;
    background-color: #f0f0f0;
}
.fifthmain {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.train {
    text-align: center;
}
.fifthbox {
    width: 1200px;
    height: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.tip-fifth {
    height: 35px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1144de;
    line-height: 34px;
    padding-top: 10px;
    text-align: center;
}
.introduce-fifth {
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #656565;
    line-height: 15px;
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: center;
}
.six {
    width: 100%;
    height: 520px;
    background: url("../../../admin/assets/images/bg4.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -30px;
}
.sixbox {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.mod {
    width: 1180px;
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}
.tip-six {
    width: 234px;
    height: 35px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1144de;
    line-height: 34px;
    margin-bottom: 20px;
}
.image-line {
    position: relative;
    left: -520px;
    top: -15px;
}
.op {
    display: grid;
    grid-template-columns: repeat(3, 370px);
    grid-template-rows: repeat(2, 150px);
    position: relative;
}
.list3 {
    width: 370px;
    height: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.head3 {
    width: 340px;
    display: flex;
}
.bottom3 {
    width: 340px;
    display: flex;
}
.date {
    width: 70px;
    height: 30px;
    font-size: 20px;
    color: #999;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    margin-right: 10px;
    margin-bottom: 10px;
    padding-left: 10px;
}
.date:hover {
    color: #0c47ea;
}
.name {
    width: 64px;
    height: 30px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #5c5c5c;
    line-height: 30px;
    margin-bottom: 10px;
}
.type {
    width: 168px;
    opacity: 0.8;
    font-size: 20px;
    height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.type:hover {
    color: #0c47ea;
}
.year {
    width: 55px;
    height: 30px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #5c5c5c;
    line-height: 30px;
    text-align: center;
    margin-right: 25px;
    padding-left: 10px;
}
.year:hover {
    color: #0c47ea;
}
.thing {
    width: 209px;
    height: 50px;
    font-size: 16px;
    padding-top: 3px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5c5c5c;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.thing:hover {
    color: #0c47ea;
}
.divid-a {
    width: 1110px;
    height: 1px;
    background-color: #b5b5b5;
    position: absolute;
    margin-top: 275px;
}
.divid-b {
    height: 230px;
    width: 1px;
    background-color: #b5b5b5;
    position: absolute;
    margin-left: -370px;
    margin-top: 155px;
}
.divid-c {
    height: 230px;
    width: 1px;
    background-color: #b5b5b5;
    position: absolute;
    margin-left: 370px;
    margin-top: 155px;
}
.divid-d {
    height: 40px;
    width: 40px;
    background-color: #ffffff;
    position: absolute;
    margin-left: -370px;
    margin-top: 260px;
}
.divid-e {
    height: 40px;
    width: 40px;
    background-color: #ffffff;
    position: absolute;
    margin-left: 370px;
    margin-top: 260px;
}
.end {
    width: 100%;
    height: 890px;
    background: url("../../../admin/assets/images/bg5.jpg") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.screen {
    width: 1160px;
    height: 820px;
    padding-left: 40px;
    padding-top: 80px;
}
.our {
    width: 136px;
    height: 40px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 32px;
}
.image-line1 {
    margin-left: -10px;
}
.foot-text {
    width: 650px;
    height: 150px;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    margin-top: -140px;
}
.unit {
    width: 250px;
    height: 18px;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 15px;
}
.unita {
    width: 600px;
    height: 36px;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}
.ut {
    display: flex;
    margin-bottom: 20px;
    margin-top: 10px;
}
.tel {
    height: 150px;
    width: 1160px;
    display: flex;
    align-items: center;
}
.telephone-1st {
    width: 350px;
    height: 43px;
    background: url("../../../admin/assets/images/tel.png") no-repeat;
    background-size: 95%;
    margin-right: 60px;
    text-align: center;
    line-height: 38px;
}
.telephone-2nd {
    width: 350px;
    height: 43px;
    background: url("../../../admin/assets/images/peo.png") no-repeat;
    background-size: 95%;
    margin-right: 60px;
    text-align: center;
    line-height: 38px;
}
.telephone-3rd {
    width: 350px;
    height: 52px;
    background: url("../../../admin/assets/images/Email.png") no-repeat;
    background-size: 100%;
    text-align: center;
    line-height: 38px;
    margin-top: 12px;
    padding-right: 12px;
}
.telephone-3rd span {
    margin-left: 40px;
}
.city {
    width: 340px;
    height: 203px;
}
.telephone {
    width: 229px;
    height: 18px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 15px;
    opacity: 0.6;
}
.footerbox {
    width: 1180px;
    display: grid;
    grid-template-columns: repeat(2, 590px);
    grid-template-rows: repeat(2, 190px);
}
.box-footer {
    width: 570px;
    margin-bottom: 20px;
    display: flex;
    background-color: #074470;
    border: 1px solid #0aa7b8;
    border-radius: 5px;
}
.box-footer-img {
    width: 125px;
    height: 120px;
    margin: 25px;
}
.box-footer-text {
    width: 390px;
    height: 130px;
    padding: 20px;
}
.box-tip-1st {
    color: #ffffff;
    font-size: 18px;
    margin-top: 5px;
    font-family: "Times New Roman", Times, serif;
    font-weight: 600;
}
.box-tip-2nd {
    color: #cde3fa;
    font-size: 13px;
    font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
        "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
    margin-top: 20px;
    line-height: 25px;
}
.screen-between {
    display: flex;
    justify-content: space-between;
}
// @media screen and (max-width:768px){
// .main{
//     width: 100%;
//     height: 400px;
// }
// .background-image2nd{
//     background: url('../../../admin/assets/images/three.png')no-repeat;
//     background-size: 100% 100%;
//     width: 102%;
//     height: 220px;
//     display: flex;
//     justify-content: center;
//     background-color: #FFFFFF;
//     flex-direction: column;
//     align-items: center;
// }
// .main3rd{
//     width: 100%;
//     display: flex;
// }
// .left{
//     width: 45%;
//     height:300px;
//     padding-top: 12px;
//     padding-left: 5%;
// }
// .right{
//     width: 45%;
//     height: 280px;
//     padding-right: 5%;
// }
// .right-img{
//     width: 100%;
//     height: 280px;
// }
// .four{
//     display: flex;
//     margin-bottom: 20px;
//     background: url('../../../admin/assets/images/hover.png')no-repeat;
//     width:100%;
//     height: 50px;
// }
// .titleline{
//     display: flex;
//     flex-direction: column;
//     width: 350px;
//     height: 50px;
// }
// .linetop{
//     width: 86px;
//     height: 20px;
//     font-size: 13px;
//     font-family: Microsoft YaHei;
//     font-weight: bold;
//     color: #0C47EA;
//     margin-top: 8px;
//     margin-bottom: 5px;
// }
// .linebottom{
//     width:280px;
//     height: 19px;
//     font-size: 12px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: #0C1F52;
// }
// .img-four{
//     width: 35px;
//     height: 35px;
//     margin-top: 10px;
//     margin-left: 10px;
//     margin-right: 10px;
// }
// .third{
//     width: 100%;
//     height: 450px;
//     background:url('../../../admin/assets/images/bg.png')no-repeat;
//     background-size: 100% 100%;
//     display: flex;
//     justify-content: center;
// }
// .fouth{
//     width: 100%;
//     height: 450px;
//     background: url('../../../admin/assets/images/bg2.png')no-repeat;
//     background-size: 100% 100%;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
// }
// .fouth-img{
//     width: 100%;
// }
// .fouthbox{
//     width: 100%;
// }
// .tip-3rd{
//     margin-top:30px;
// }
// .fifth{
//     width: 100%;
//     height: 420px;
//     background-color:#F0F0F0;
// }
// .fifthbox{
//     width: 100%;
//     height: 420px;
// }
// .fifth-img{
//     width: 100%;
// }
// .introduce-fifth{
//     margin-top: 30px;
//     margin-bottom: 25px;
// }
// .six{
//     height: 420px;
// }
// .sixbox{
//     width: 768px;
// }
// .mod{
//     width:730px;
// }
// .list3{
//     width:234px;
// }
// .head3{
//     width: 200px;
//     display:flex;
// }
// .bottom3{
//     width: 200px;
//     display:flex;
// }
// .date{
//     width: 40px;
// }
// .op{
//     display: grid;
//     grid-template-columns:repeat(3,234px);
//     grid-template-rows: repeat(2,140px);
//     position: relative;
// }
// .divid-a{
//     width: 90%;
//     margin-top: 265px;
// }
// .divid-b{
//     height: 230px;
//     margin-left:-230px;
//     margin-top: 155px;
// }
// .divid-c{
//     height: 230px;
//     margin-left: 200px;
//     margin-top: 155px;
// }
// .divid-d{
//     height: 40px;
//     width: 40px;
//     margin-left: -220px;
//     margin-top: 250px;
// }
// .divid-e{
//     height: 40px;
//     width: 40px;
//     background-color: #FFFFFF;
//     position: absolute;
//     margin-left: 200px;
//     margin-top: 250px;
// }
// .thing{
//     width: 150px;
//     height: 50px;
//     font-size: 15px;
// }
// .type{
//     width: 150px;
//     font-size: 16px;
//     height: 40px;
// }
// .year{
//     width: 55px;
//     font-size: 16px;
//     margin-right: 15px;
//     padding-left: 5px;
// }
// .date{
//     width: 60px;
//     height: 30px;
//     font-size: 17px;
// }
// .image-line{
//     position:relative;
//     left: -290px;
//     top: -15px;
// }
// .end{
//     width: 100%;
//     height:825px;
// }
// .screen{
//     width:688px;
//     height:680px;
//     padding:40px 40px;
// }
// .our{
//     width: 136px;
//     height: 32px;
//     font-size: 28px;
//     margin-top: 20px;
// }
// .image-line1{
//     margin-left: -10px;
//     margin-top: 10px;
// }
// .foot-text{
//     width: 350px;
//     height: 130px;
//     font-size: 10px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: #FFFFFF;
//     line-height: 20px;
//     margin-top: 20px;
// }
// .unit{
//     width: 180px;
//     height: 18px;
//     font-size: 9px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: #FFFFFF;
//     line-height: 15px;
// }
// .unita{
//     width: 480px;
//     height: 36px;
//     font-size: 11px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: #FFFFFF;
// }
// .ut{
//     display: flex;
//     margin-bottom: 20px;
//     margin-top: 10px;
// }
// .tel{
//     height: 100px;
//     width: 700px;
//     display: flex;
//     align-items: center;
// }
// .telephone-1st{
//     width: 200px;
//     height: 33px;
//     margin-right: 20px;
//     line-height: 18px;
// }
// .telephone-2nd{
//     width: 200px;
//     height: 33px;
//     margin-right: 20px;
//     line-height: 18px;
// }
// .telephone-3rd{
//     width: 200px;
//     height:42px;
//     line-height: 18px;
//     margin-top:12px;
//     padding-right:12px;
// }
// .city{
//     width: 240px;
//     height: 180px;
//     position: absolute;
//     left: 410px;
// }
// .telephone{
//     width: 200px;
//     height: 18px;
//     font-size: 10px;
//     font-family: Microsoft YaHei;
//     font-weight: 400;
//     color: #FFFFFF;
//     line-height: 15px;
//     opacity: 0.6;
// }
// }
</style>
